import { createRestApiPreset } from '@npm-registry/helpers/request';
import Cookies from 'js-cookie';

import { COOKIE_REGION_ID } from '../../consts';
import { baseApiUrl } from './consts';

const getTokensFromStorage = () => {
  const userToken = localStorage.getItem('user-token');
  const cartToken = localStorage.getItem('cart-token');

  const resultTokensMap: {
    'user-token'?: string;
    'cart-token'?: string;
  } = {};

  if (userToken) {
    resultTokensMap['user-token'] = userToken;
  }

  if (cartToken) {
    resultTokensMap['cart-token'] = cartToken;
  }

  return resultTokensMap;
};

export const eaptekaApi = createRestApiPreset(baseApiUrl, {
  headers: {
    platform: 'frontend',
    'region-id': Cookies.get(COOKIE_REGION_ID),
    'api-key': 'K<8RNCa^ft86LnNa',
    ...getTokensFromStorage()
  }
});

export const responseHandler = async <
  T = undefined,
  U = undefined
>(
  response: Response,
  serializer?: (arg: U) => T
): Promise<T> => {
  if (!response.ok) {
    response
      .json()
      .then(({ message }) => {
        throw new Error(message || response.statusText);
      })
      .catch(() => {
        throw new Error(response.statusText);
      });
  }

  if (response.status === 204) {
    return {} as T;
  }

  const data = await response.json();

  return serializer ? serializer(data) : data;
};
